<template>
  <div class="pc-info">
    <award-notice-wrapper />
    <div class="bg-white p-5 rounded-medium leading-base" ref="info">
      <div class="title text-center text-20 p-5" v-html="$bus.survey.titlex"></div>
      <div class="desc py-5 px-8 bg-theme-gray rounded-small" v-if="desc" v-html="desc"></div>
      <div class="desc bg-white rounded-small" v-else></div>
      <div class="text-center mt-10">
        <el-button :disabled="$bus.loading" type="primary" @click="startAnswer">{{ startText }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultsSurveyAttr } from 'dygc'
import AwardNotice from '@/components/AwardNotice'
import { previewImage } from '@/assets/js/preview-image'
import AwardNoticeWrapper from '@/components/reward/AwardNoticeWrapper.vue'
export default {
  name: 'PcInfo',
  components: { AwardNotice,AwardNoticeWrapper },
  computed: {
    desc() {
      return this.$bus.survey.welcome || ''
    },
    startText() {
      return this.$bus.buttonOption.startText
    },
    award() {
      return this.$bus.award
    },
    share() {
      return this.$bus.share
    }
  },
  created() {},
  methods: {
    startAnswer() {
      this.$bus.onStart()
    }
  },
  mounted() {
    previewImage(this.$refs.info)
  }
}
</script>

<style scoped lang="scss">
@keyframes myMove {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-65px);
  }
}

.pc-info {
  width: 960px;
  margin: 0 auto;

  .award-wrapper {
    height: 20px;
    overflow: hidden;

    .award {
      &.animate {
        animation: myMove 5s ease-in infinite;
        transition: all 3s ease 0s;
        animation-fill-mode: forwards;
      }
    }
  }
}
</style>
